var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
export const UserContext = createContext(undefined);
export function UserProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const fetchUserInfo = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            const response = yield fetch('/api/inside/v1/user_info', {
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                const data = yield response.json();
                if (data.status === 'success') {
                    setCurrentUser(data.data);
                }
                else {
                    setCurrentUser(null);
                }
            }
            else {
                setCurrentUser(null);
            }
        }
        catch (_error) {
            setCurrentUser(null);
        }
        finally {
            setIsLoading(false);
        }
    }), []);
    useEffect(() => {
        fetchUserInfo();
    }, [fetchUserInfo]);
    return (React.createElement(UserContext.Provider, { value: { currentUser, setCurrentUser, isLoading, refetchUser: fetchUserInfo } }, children));
}
export function useUser() {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
}
